









import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class AppLightModal extends Vue {
  @Prop({ type: [Number], default: 48 }) readonly left!: number
  @Prop({ type: String, default: 'white' }) readonly bg!: string
  @Prop({ type: Boolean, default: true }) readonly overlay!: boolean

  @Emit()
  hide () {}
}
